module.exports = __webpack_public_path__ + "img/class3.0efb0e1a.png";